import Box from "@mui/material/Box";
import type { ContentSchedule } from "entities/contentSchedule/types";
import CollapsibleTable from "shared/components/CollapsibleTable";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import SearchField from "shared/components/SearchField";
import ModuleDetailsDrawerContainer from "./components/ModuleDetailsDrawer";
import { ContentScheduleProvider, useContentSchedule } from "./context";
import { contentScheduleColumns, renderModuleRow } from "./helpers";
import { useContentScheduleFilter } from "./hooks/useContentScheduleFilter";
import { groupModulesByMonth } from "./utils";

const ContentScheduleContainer = () => (
  <ContentScheduleProvider>
    <ContentScheduleComponent />
  </ContentScheduleProvider>
);

const ContentScheduleComponent = () => {
  const {
    contentSchedule,
    loading,
    updateContentModuleStatus,
    moduleDetailsDrawer,
  } = useContentSchedule();
  const { filtersData, filteredModules, searchValue, setSearchValue } =
    useContentScheduleFilter(contentSchedule);

  const groups = groupModulesByMonth(filteredModules).map((group) => ({
    ...group,
    initiallyExpanded: true,
  }));

  const handleEdit = (module: ContentSchedule) => {
    moduleDetailsDrawer.openDrawer(module);
  };

  return (
    <FlexColumn>
      <PageHeading />

      <FlexColumn marginTop="1rem">
        <FlexCenter
          marginBottom={"1rem"}
          gap="1rem"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          flexWrap="wrap"
        >
          <SearchField
            placeholder="Search..."
            value={searchValue}
            onChange={setSearchValue}
          />

          <Box display="flex" gap="1rem">
            {filtersData.map((filterProps) => (
              <Filter key={filterProps.title} {...filterProps} />
            ))}
          </Box>
        </FlexCenter>

        <CollapsibleTable
          columns={contentScheduleColumns}
          groups={groups}
          renderRow={(module: ContentSchedule) =>
            renderModuleRow({
              module,
              handleEdit,
              updateContentModuleStatus,
            })
          }
          noDataMessage="No Results Found"
          isLoading={loading}
        />
      </FlexColumn>
      <ModuleDetailsDrawerContainer />
    </FlexColumn>
  );
};

export default ContentScheduleContainer;
